export default "__VITE_ASSET__TcMVCwDy__"